import z from "zod";

const sqsErrorTypeValues = [
  "MESSAGE_SEND_FAILED",
  "MESSAGE_RECEIVE_FAILED",
  "MESSAGE_UNDEFINED",
  "INVALID_MESSAGE_BODY",
  "MESSAGE_TOO_LARGE",
] as const;

const sqsErrorTypeSchema = z.enum(sqsErrorTypeValues);
const SqsErrorType = sqsErrorTypeSchema.enum;
type SqsErrorType = z.infer<typeof sqsErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type SqsErrors =
  | {
      errorType: typeof SqsErrorType.MESSAGE_SEND_FAILED;
      data: {
        queueUrl?: string;
        messageBody?: unknown;
        error?: string;
      };
    }
  | {
      errorType: typeof SqsErrorType.MESSAGE_RECEIVE_FAILED;
      data: {
        queueUrl?: string;
        error?: string;
      };
    }
  | {
      errorType: typeof SqsErrorType.MESSAGE_UNDEFINED;
      data: {
        queueUrl?: string;
      };
    }
  | {
      errorType: typeof SqsErrorType.INVALID_MESSAGE_BODY;
      data: {
        queueUrl?: string;
        messageBody?: unknown;
      };
    }
  | {
      errorType: typeof SqsErrorType.MESSAGE_TOO_LARGE;
      data: {
        route?: string;
        id?: string;
        byteSize: number;
        limit: number;
      };
    };

export const sqsErrorDetails: Record<SqsErrorType, ErrorDetails> = {
  [SqsErrorType.MESSAGE_SEND_FAILED]: {
    sentryDescription: "Failed to send message to SQS queue",
  },
  [SqsErrorType.MESSAGE_RECEIVE_FAILED]: {
    sentryDescription: "Failed to receive message from SQS queue",
  },
  [SqsErrorType.MESSAGE_UNDEFINED]: {
    sentryDescription: "SQS message was undefined when expected",
  },
  [SqsErrorType.INVALID_MESSAGE_BODY]: {
    sentryDescription: "Invalid SQS message body format",
  },
  [SqsErrorType.MESSAGE_TOO_LARGE]: {
    sentryDescription: "SQS message body exceeds the 256KB size limit",
  },
};
